// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --font-color: #424242;
  --bg-color: #fff;
  --bg-color-rgb1: rgba(255, 255, 255, 0.322);
  --bg-color-rgb2: rgba(255, 255, 255, 0.5);
  --bg-color2: #f8f8f8;
  --bg-color3: #fff;
  --ptt-bg-color: #e1e1e1;
  --link-new-msgs-bgcolor: #fff;
  --slide-arrow-color: #fff;
  --slide-arrow-bg: #bdbdbd;
  --heading-color: #292922;
  --main-body-color: #000000e6;
  --main-body-bgcolor: #f8f8f8;
  --box-shadow: 0px 0px 17px #313131;
  --toolbtn-color: #757575;
  --toolbtn-color-hover: #a5a5a5;
  --toolbtn-active-color: #00aafb;
  --activity-line-bgcolor: #0277bd;
  --dropdown-color: #292922;
  --chat-text-color: #7c7c7c;
  --chat-time-color: #808080;
  --chat-system-color: #808080;
  --chatlist-icon-color: #545454;
  --message-bg-color1: #D8F6F7;
  --message-bg-color2: #F0F0F0;
  --message-next-color: #83C1EF;
  --message-time-color: #808080;
  --message-grey-color: grey;
  --message-reply-color: grey;
  --message-reply-bgcolor: #254b6a08;
  --message-selected-bgcolor: #dbdbdb;
  --switch-enabled-color: #2196F3;
  --switch-disabled-color: #ccc;
  --switch-btn-bgcolor: var(--bg-color);
  --fwd-message-color: #808080;
  --content-container-bgcolor: #fff;
  --list-item-bgcolor: #fff;
  --bot-message-color: #23527c;
  --list-item-activebgcolor: #ebebeb82;
  --list-item-bghover: #f8f8f870;
  --list-item-horline-color: #F0F0F0;
  --list-item-bordercolor: #f0f0f0;
  --list-item-bordercolor2: #f0f0f0;
  --contact-list-marked-bg: #ccd1d3;
  --context-color: var(--main-body-color);
  --context-bgcolor: var(--bg-color);
  --context-bgcolor-hover: var(--bg-color-hover);
  --btn-bghover: #e8eef7;
  --progress-bg: #e8eef7;
  --pub-footer-active: lightgrey;
  --main-block-border-top: #d3d3d3;
  --main-block-border-left: #d3d3d3;
  --border-top-input: #ccc;
  --border-info-left: #ccc;
  --border-bottom-section: #ccc;
  --border-bottom-selecteditems: #f0f0f0;
  --circle-animation-bgcolor: #d3d5d385;
  --circle-animation-color: #333;
  --circle-animation-hover: #a5a5a5;
  --vert-line-color: #d3d3d3;
  --hor-line-color: #f0f0f0;
  --asc-item-border-bottom: #f2f2f2;
  --asc-status-hover: #fcfcfc;
  --item-bgcolor-hover: #fcfcfc;
  --transition-wrapper-bgcolor: #f2f2f2;
  --chat-item-right-block-bg: #ccd1d3;
  --message-link-color: #6083a2;
  --message-system-color: #6083a2;
  --message-system-bgcolor: #e4e4e4;
  --message-left-bgcolor: #F0F0F0;
  --message-right-bgcolor: #D8F6F7;
  --search-input-bgcolor: #e7e7e7;
  --search-more-border: #e7e7e7;
  --search-rail-border: #f7f7f7;
  --datepicker-cell-hover: #eaf8fe;
  --datepicker-border-color: #d9d9d9;
  --emoji-input-color: #808080;
  --emoji-input-border: #d9d9d9;
  --emoji-placeholder-color: #888888;
  --emoji-hover-before: #f4f4f4;
  --info-content-shadow: rgba(16, 15, 15, 0.43);
  --icon-bgcolor: #ccd1d3;
  --icon-bgcolor2: #00a2ff;
  --blue-bgcolor: #005aab;
  --like-color: #7f9eb9;
  --blue-login-bgcolor: #005aab;
  --blue-login-bgcolor-hover: #00489A;
  --comment-btn-bgcolor: #d8dade;
  --comment-btn-bgcolor-hover: #a5a5a5;
  --base-blue-color: #0277bd;
  --base-blue-color2: #2196F3;
  --special-blue-color: #008ef7;
  --special-blue-color2: #2688c2;
  --icon-color: #ffffff;
  --icon-special-color: #2196f3;
  --icon-marked-color: #ffffff;
  --icon-btn-color: #fff;
  --icon-border-color: #fff;
  --icon-btn-bgcolor: #9C9C9C;
  --icon-wrapper-bgcolor: rgba(39, 39, 39, 0.21);
  --icon-wrapper-bgcolor-hover: #272727ba;
  --icon-btn-bgcolorhover: #535555;
  --icon-roundbtn-color: #2196f3;
  --icon-disabled-color: #7b7b7b;
  --icon-btn-hover: #f0f0f07f;
  --icon-btn-with-bg: #f0f0f0;
  --custom-textarea-color: grey;
  --listitem-headerfooter-color: grey;
  --placeholder-color: #aaa;
  --custom-textarea-color: #868686;
  --bg-color-hover: #f3f3f3;
  --divider-color: #f0f0f0;
  --scroll-bar-color: rgba(0, 0, 0, 0.2);
  --shifted-circle-border-color: lightgrey;
  --conf-subheader-color: rgba(0, 0, 0, 0.55);
  --conf-tab-hover: #cdd7ea;
  --custom-tab-activebg: #e7e7e7;
  --custom-tab-activeborder: #8a8080;
  --custom-tab-border: #d2cece;
  --custom-tab-hover: #dedede;
  --link-new-message-shadow: #999;
  --bootstrap-btn-color: #fff;
  --func-btn-bgcolor: #F5F5F5;
  --func-btn-bgactive: #929292;
  --ref-link-color: #337ab7;
  --ref-link-color-hover: #23527c;
  --input-text-color: var(--custom-textarea-color);
  --input-bg-color: #fff;
  --clip-elem-bgcolor: #fff;
  --clip-elem-shadow-color: rgba(0, 0, 0, 0.4);
  --clip-cont-color: #808080;
  --clip-cont-bgcolor: #f8f8f89e;
  --phone-container-shadow: rgba(50, 50, 50, 0.5);
  --mediaviewer-caption-bg: rgba(255, 255, 255, 0.7);
  --modal-elem-color: #0097d3;
  --modal-text-color: #757575;
  --badge-red-color: red;
  --elem-grey-color: #808080;
  --elem-red-color: red;
  --elem-green-color: green;
  --conf-green-color: #00a91d;
  --reply-red-color: var(--reply-red-color);
  --phone-text-color: #7e7e7e;
  --dialer-color: #4e4e4e;
  --dialer-bgcolor: #fff;
  --dialer-color-special: #868686;
  --dialer-input-color: #3F3F3F;
  --dial-button-bgcolor: #20B000;
  --login-color: gray;
  --login-bgcolor: #dadada;
  --btns-block-color: #aaa;
  --login-btns-bgcolor: #f5f5f5;
  --videomost-main-bgcolor: #4f4c50;
  --videomost-videocont-bgcolor: #585559;
  --videomost-members-container: #4f4c50b8;
  --vm-bg-color: rgba(79, 76, 80, 0.9);
  --vm-bg-color-hover: #736e75;
  --vm-divider-color: gray;
  --vm-text-color: white;
  --vm-title-color: lightgray;
  --vm-footer-color: lightgray;
  --vm-border-color: lightgray;
  --vm-nocamera-bg: #534f54;
  --vm-handup-wrapper-bg: #534f54;
  --vm-btn-active: #7a818c2e;
  --calendar-bg-color: var(--content-container-bgcolor);
  --calendar-month-color: #2196f3;
  --calendar-arrow-color: #686868;
  --calendar-header-btn-hover-bg-color: #0c7bd3;
  --calendar-header-btn-color: #2196f3;
  --calendar-day-not-current-month-color: #7a7a7a;
  --calendar-day-bg-color: var(--content-container-bgcolor);
  --calendar-day-border-color: #c8cbd160;
  --calendar-today-bg-color: #aec1d76b;
  --calendar-today-border-color: #69AEE4;
  --calendar-not-current-month-bg: #35414ca8;
  --calendar-month-name-color: #5b95c3;
  --calendar-hover-bg: #aabfd354;
  --calendar-hover-border-color: #e7e0e0;
  --calendar-event-color: #11a322;
  --calendar-event-hover-bg: #9bcaf987;
  --calendar-event-bottom-border-color: #7777772e;
  --calendar-events-bg: #acc6e1;
  --calendar-events-panel-bg: #2196f3;
  --calendar-events-content-bg: var(--content-container-bgcolor);
  --calendar-events-btn-bg: #2196f3;
  --calendar-events-btn-hover-bg: #0c7bd3;
  --calendar-edit-events-bg: var(--content-container-bgcolor);
  --calendar-edit-events-hover-bg: #e7e4e4;
  --calendar-edit-events-time-color: #D83B01;
  --disabled-overlay-bg: #bdbdbd;
  --unsent-replymsg-fio-color: #9d150c;
  --unsent-replymsg-text-color: #636161;
  --item-color-0: #f44336;
  --item-color-1: #9c27b0;
  --item-color-2: #2196F3;
  --item-color-3: #4caf50;
  --item-color-4: #00bcd4;
  --item-color-5: #b71c1c;
  --item-color-6: #1a237e;
  --item-color-7: #e91e63;
  --item-color-8: #455a64;
  --item-color-9: #afb42b;
  --item-color-10: #f57f17;
  --item-color-11: #b7822c;
  --item-color-12: #607d8b;
  --item-color-13: #3f51b5;
  --item-color-14: #8083d9;
  --item-color-15: #33691e;
  --item-color-16: #8bc34a;
  --item-color-17: #880e4f;
  --item-color-18: #ba4482;
  --item-color-19: #673ab7;
  --item-color-20: #0d47a1;
  --item-color-21: #006064;
  --item-color-22: #009688;
  --item-color-23: #004d40;
  --item-color-24: #827717;
  --item-color-25: #ffc107;
  --item-color-26: #e65100;
  --item-color-27: #00b39c;
  --item-color-28: #ff5722;
  --item-color-29: #bf360c;
  --item-color-30: #b4876e;
  --item-color-31: #795548;
  --item-color-32: #3e2723;
  --item-color-33: #465776;
  --item-color-34: #d500f9;
  --item-color-35: #651fff;
  --item-color-gray: #808080;
  --highlighted-bgcolor: #699fbd;
  --reaction-count-color: black;
  --reaction-panel-color: white;
  --reactions-items-toolbox-bgcolor: #d9d9d9e1;
  --reactions-items-bgcolor: #cbc8c84f;
  --reactions-picker-icon: #bbbbbb;
  --reactions-panel-color: var(--message-grey-color);
  --reactions-panel-totalbgcolor: #cbc8c84f;
  --tetra-msg-notsent-color: rgba(0, 0, 0, 0.856);
  --tetra-msg-notsent-bgcolor: #ff5353;
  --bg-sound-btn: var(--bg-color2);
  --bg-sound-btn-hover: #cbc8c84f;
  --comments-color: #646464;
  --comments-border-top: #cbc8c84f;
  --bg-comments-hover-left: #8181814f;
  --bg-comments-hover-right: #aeebed;
  --bg-comments-after-hover: #aeebed;
  --code-block-font-color: #ffffff;
  --electron-notyfy-bg-color: 0px 0px 10px 0px rgba(50, 50, 50, 0.5);
  --notyfy-title-subtitle-color: #6e6e6e;
  --search-line-color: #2196f3;
  --search-option-color-hover: #fff;
  --search-option-bg-hover: #2196f3;
  --group-link-message-color: #696868;
  --group-join-line-color: var(--border-bottom-section);
  --vh: 1vh;
  --vw: 1vw;
}
@supports (height: 100dvh) {
:root {
    --vh: 1dvh;
}
}
@supports (height: 100dvw) {
:root {
    --vw: 1dvw;
}
}
[data-theme="dark"] {
  --font-color: #ffffff;
  --bg-color: #151e27;
  --bg-color-rgb1: rgba(91, 149, 195, 0.1);
  --bg-color-rgb2: rgba(91, 149, 195, 0.2);
  --bg-color2: #151e27;
  --bg-color3: #1d2733;
  --ptt-bg-color: #222d3a;
  --link-new-msgs-bgcolor: #2e3b4a;
  --slide-arrow-color: #fff;
  --slide-arrow-bg: #2e3b4a;
  --heading-color: #030303;
  --main-body-color: rgba(248, 244, 244, 0.9);
  --main-body-bgcolor: #1f1f27;
  --box-shadow: 0px 0px 17px #313131;
  --toolbtn-color: #7a90af;
  --toolbtn-color-hover: #3b7db5;
  --toolbtn-active-color: #5b95c3;
  --activity-line-bgcolor: #0470af;
  --dropdown-color: #808080;
  --chat-text-color: #BDBDBD;
  --chat-time-color: #808080;
  --chat-system-color: #ffffff;
  --chat-item-right-block-bg: #646464;
  --chatlist-icon-color: #bbb8b8;
  --message-bg-color1: #704d4d;
  --message-bg-color2: #232323;
  --message-next-color: #b4c8d8;
  --message-time-color: #81a0ba;
  --message-link-color: #6083a2;
  --message-system-color: #6083a2;
  --message-system-bgcolor: #212d3b;
  --message-left-bgcolor: #222e3a;
  --message-right-bgcolor: #295476;
  --bot-message-color: #b8cbdb;
  --message-grey-color: #81a0ba;
  --message-reply-color: #93b8d6;
  --message-reply-bgcolor: #1d3d5833;
  --message-selected-bgcolor: #1a2734;
  --switch-enabled-color: #2688c2;
  --switch-disabled-color: #565656;
  --switch-btn-bgcolor: #96a8b7;
  --fwd-message-color: #81a0ba;
  --content-container-bgcolor: #17212b;
  --list-item-bgcolor: #17212b;
  --list-item-activebgcolor: #43464852;
  --list-item-bghover: #212d3b;
  --list-item-horline-color: #2c2c2c;
  --list-item-bordercolor: var(--message-bg-color2);
  --list-item-bordercolor2: #565050;
  --contact-list-marked-bg: #424242;
  --context-color: var(--main-body-color);
  --context-bgcolor: #1b2833;
  --context-bgcolor-hover: var(--bg-color-hover);
  --btn-bghover: #212d3b;
  --progress-bg: #535353;
  --pub-footer-active: #212d3ba8;
  --main-block-border-top: var(--message-bg-color2);
  --main-block-border-left: #353535;
  --border-top-input: #353535;
  --border-info-left: #353535;
  --border-bottom-section: #353535;
  --border-bottom-selecteditems: var(--message-bg-color2);
  --circle-animation-bgcolor: #535b6677;
  --circle-animation-color: #333;
  --circle-animation-hover: var(--toolbtn-color-hover);
  --vert-line-color: var(--message-bg-color2);
  --hor-line-color: var(--message-bg-color2);
  --asc-item-border-bottom: var(--message-bg-color2);
  --asc-status-hover: var(--list-item-bghover);
  --item-bgcolor-hover: var(--list-item-bghover);
  --transition-wrapper-bgcolor: #696969;
  --search-input-bgcolor: #212d3b;
  --search-more-border: var(--message-bg-color2);
  --search-rail-border: var(--message-bg-color2);
  --datepicker-cell-hover: var(--list-item-bghover);
  --datepicker-border-color: var(--message-bg-color2);
  --emoji-input-color: var(--toolbtn-color);
  --emoji-input-border: var(--message-bg-color2);
  --emoji-placeholder-color: var(--toolbtn-color);
  --emoji-hover-before: #231818;
  --info-content-shadow: rgba(164, 164, 164, 0.08);
  --blue-bgcolor: #004067;
  --like-color: #4e87b3;
  --icon-bgcolor: #4e87b3;
  --icon-bgcolor2: #4e87b3;
  --base-blue-color: #4e87b3;
  --base-blue-color2: #22659a;
  --special-blue-color: #4e87b3;
  --blue-login-bgcolor: #22659a;
  --special-blue-color2: #22659a;
  --blue-login-bgcolor-hover: #1d4169;
  --comment-btn-bgcolor: #22659a;
  --comment-btn-bgcolor-hover: #1d4169;
  --icon-color: var(--font-color);
  --icon-special-color: #5b95c3;
  --icon-marked-color: #ffffff;
  --icon-btn-hover: #434f58c9;
  --icon-btn-with-bg: #27323e;
  --icon-btn-color: #22659a;
  --icon-border-color: var(--toolbtn-color);
  --icon-btn-bgcolor: #3c4652;
  --icon-wrapper-bgcolor: rgba(39, 39, 39, 0.21);
  --icon-wrapper-bgcolor-hover: #272727ba;
  --icon-btn-bgcolorhover: #35393c;
  --icon-roundbtn-color: #4886b7;
  --icon-disabled-color: #7b7b7b;
  --custom-textarea-color: #fff;
  --listitem-headerfooter-color: #abb0b7;
  --placeholder-color: #abb0b7;
  --divider-color: var(--message-bg-color2);
  --bg-color-hover: #212d3b;
  --scroll-bar-color: rgba(194, 192, 192, 0.2);
  --shifted-circle-border-color: var(--font-color);
  --conf-subheader-color: var(--font-color);
  --conf-tab-hover: var(--bg-color-hover);
  --custom-tab-activebg: #354354a8;
  --custom-tab-activeborder: #704d4d;
  --custom-tab-border: var(--message-bg-color2);
  --custom-tab-hover: #354354a8;
  --link-new-message-shadow: #212d3b;
  --bootstrap-btn-color: #fff;
  --func-btn-bgcolor: #27323e;
  --func-btn-bgactive: #668aa9;
  --ref-link-color: #83b7dd;
  --ref-link-color-hover: #23527c;
  --input-text-color: #fff;
  --input-bg-color: #3c4652;
  --clip-elem-bgcolor: #404448;
  --clip-elem-shadow-color: rgba(0, 0, 0, 0.4);
  --clip-cont-color: var(--font-color);
  --clip-cont-bgcolor: #404448ad;
  --phone-container-shadow: rgba(0, 0, 0, 0.4);
  --mediaviewer-caption-bg: #02020285;
  --modal-elem-color: #3b7db5;
  --modal-text-color: #fff;
  --badge-red-color: #e04d4d;
  --elem-grey-color: #81a0ba;
  --elem-red-color: #d25050;
  --elem-green-color: green;
  --conf-green-color: green;
  --reply-red-color: #d25050;
  --phone-text-color: var(--chat-text-color);
  --dialer-color: #558fbe;
  --dialer-bgcolor: #1a2129;
  --dialer-color-special: #6295be;
  --dialer-input-color: #6295be;
  --dial-button-bgcolor: #1b3c1b;
  --login-color: #fff;
  --login-bgcolor: #1d2733;
  --btns-block-color: #3c4652;
  --login-btns-bgcolor: #3c4652;
  --videomost-main-bgcolor: #1e2833;
  --videomost-videocont-bgcolor: #293440;
  --videomost-members-container: #1e2833bd;
  --vm-bg-color: #232d38d3;
  --vm-bg-color-hover: #4b56618f;
  --vm-divider-color: var(--message-bg-color2);
  --vm-text-color: var(--font-color);
  --vm-title-color: rgba(255, 255, 255, 0.9);
  --vm-footer-color: #1d2733;
  --vm-border-color: #1d2733;
  --vm-nocamera-bg: #293440;
  --vm-handup-wrapper-bg: var(--vm-bg-color);
  --vm-btn-active: #7a818c2e;
  --calendar-bg-color: #212d3b;
  --calendar-month-color: #5b95c3;
  --calendar-arrow-color: #686868;
  --calendar-header-btn-color: #5b93c3;
  --calendar-header-btn-hover-bg-color: #34638d7a;
  --calendar-day-not-current-month-color: #ffffffb3;
  --calendar-day-bg-color: #212d3b;
  --calendar-day-border-color: #181b2098;
  --calendar-today-bg-color: #2b47686b;
  --calendar-today-border-color: #69AEE4;
  --calendar-not-current-month-bg: #35414ca8;
  --calendar-month-name-color: #5b95c3;
  --calendar-hover-bg: #3f83c354;
  --calendar-hover-border-color: #625a5a;
  --calendar-event-color: #70c37a;
  --calendar-event-hover-bg: #212d3b87;
  --calendar-event-bottom-border-color: #7777772e;
  --calendar-events-bg: #1d232a;
  --calendar-events-panel-bg: #34648d;
  --calendar-events-content-bg: #2a2a2a;
  --calendar-events-btn-bg: #34648d;
  --calendar-events-btn-hover-bg: #34638d7a;
  --calendar-edit-events-bg: #363636cc;
  --calendar-edit-events-hover-bg: #34638d21;
  --calendar-edit-events-time-color: #D83B01;
  --disabled-overlay-bg: #bdbdbd42;
  --unsent-replymsg-fio-color: #cd1b0f;
  --unsent-replymsg-text-color: #cd1b0f;
  --item-color-0: #df4035;
  --item-color-1: #b845cc;
  --item-color-2: #2196F3;
  --item-color-3: #51c255;
  --item-color-4: #00bcd4;
  --item-color-5: #c94141;
  --item-color-6: #6d7bff;
  --item-color-7: #e94079;
  --item-color-8: #587482;
  --item-color-9: #afb42b;
  --item-color-10: #f57f17;
  --item-color-11: #b7822c;
  --item-color-12: #7fb9d6;
  --item-color-13: #5d6bb9;
  --item-color-14: #8083d9;
  --item-color-15: #539a37;
  --item-color-16: #8bc34a;
  --item-color-17: #ce2f84;
  --item-color-18: #ba4482;
  --item-color-19: #8461c3;
  --item-color-20: #2063cc;
  --item-color-21: #1b959a;
  --item-color-22: #2e998e;
  --item-color-23: #049078;
  --item-color-24: #827717;
  --item-color-25: #ffc107;
  --item-color-26: #e65100;
  --item-color-27: #00b39c;
  --item-color-28: #ff5722;
  --item-color-29: #bf360c;
  --item-color-30: #b4876e;
  --item-color-31: #be978a;
  --item-color-32: #b46556;
  --item-color-33: #a5a5a5;
  --item-color-34: #d500f9;
  --item-color-35: #651fff;
  --item-color-gray: #adadad;
  --highlighted-bgcolor: #b4c8d8;
  --reaction-count-color: white;
  --reaction-panel-color: white;
  --reactions-items-toolbox-bgcolor: #2c3438e3;
  --reactions-items-bgcolor: #08090a26;
  --reactions-picker-icon: var(--elem-grey-color);
  --reactions-panel-color: var(--message-grey-color);
  --reactions-panel-totalbgcolor: #1217184a;
  --tetra-msg-notsent-color: var(--font-color);
  --tetra-msg-notsent-bgcolor: #ff5353;
  --bg-sound-btn: var(--bg-color3);
  --bg-sound-btn-hover: #3447587a;
  --comments-color: #e8e8e8;
  --comments-border-top: #a5aaaf6b;
  --bg-comments-hover-left: #676e76;
  --bg-comments-hover-right: #357ab1;
  --bg-comments-after-hover: #244865;
  --code-block-font-color: #ffffff;
  --electron-notyfy-bg-color: 0px 0px 10px 0px #0f0f0fc9;
  --notyfy-title-subtitle-color: #d5d5d5;
  --search-line-color: #153f62;
  --search-option-color-hover: #96a7c0;
  --search-option-bg-hover: #153f62;
  --group-link-message-color: var(--font-color);
  --group-join-line-color: #8787874a;
}
.theme-videoconf {
  --bg-color: var(--vm-bg-color);
  --bg-color-hover: var(--vm-bg-color-hover);
  --bd-filter: blur(5px);
  --divider-color: var(--vm-divider-color);
  --text-color: var(--vm-text-color);
  --title-color: var(--vm-title-color);
  --footer-color: var(--vm-footer-color);
  --border-color: var(--vm-boder-color);
}
.theme-videoconf .context-menu-group > .header {
  background-color: inherit;
}
.theme-videoconf .list-item {
  color: white;
  background-color: inherit;
}
.theme-videoconf .item-footer {
  color: var(--chat-text-color);
}
.incomming-call {
  height: 300px;
  width: 310px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  user-select: none;
  border-radius: 10px;
  background-color: var(--bg-color);
  right: 0;
  bottom: 0;
  margin: auto;
  -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
  z-index: 100;
  margin: 10px;
}
.incomming-call .close-btn {
  position: absolute;
  top: 7px;
  right: 11px;
  color: #D1D1D1;
  cursor: pointer;
  font-size: 15px;
}
.incomming-call .close-btn:hover {
  color: #9e9a9a;
}
.incomming-call .icon-big {
  width: 100px;
  min-width: 100px;
  height: 100px;
  line-height: 100px;
  font-size: 42px;
  margin-top: 30px;
}
.incomming-call .name {
  font-size: 20px;
  margin-top: 10px;
  max-width: 250px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: var(--font-color);
}
.incomming-call .type {
  color: var(--message-grey-color);
  font-size: 14px;
}
.incomming-call .buttons {
  display: flex;
  justify-content: space-around !important;
  width: 100%;
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/phone/IncommingCall.vue"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,2CAA2C;EAC3C,yCAAyC;EACzC,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,kCAAkC;EAClC,wBAAwB;EACxB,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;EAChC,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,kCAAkC;EAClC,mCAAmC;EACnC,+BAA+B;EAC/B,6BAA6B;EAC7B,qCAAqC;EACrC,4BAA4B;EAC5B,iCAAiC;EACjC,yBAAyB;EACzB,4BAA4B;EAC5B,oCAAoC;EACpC,8BAA8B;EAC9B,kCAAkC;EAClC,gCAAgC;EAChC,iCAAiC;EACjC,iCAAiC;EACjC,uCAAuC;EACvC,kCAAkC;EAClC,8CAA8C;EAC9C,sBAAsB;EACtB,sBAAsB;EACtB,8BAA8B;EAC9B,gCAAgC;EAChC,iCAAiC;EACjC,wBAAwB;EACxB,wBAAwB;EACxB,6BAA6B;EAC7B,sCAAsC;EACtC,qCAAqC;EACrC,8BAA8B;EAC9B,iCAAiC;EACjC,0BAA0B;EAC1B,yBAAyB;EACzB,iCAAiC;EACjC,2BAA2B;EAC3B,6BAA6B;EAC7B,qCAAqC;EACrC,mCAAmC;EACnC,6BAA6B;EAC7B,+BAA+B;EAC/B,iCAAiC;EACjC,+BAA+B;EAC/B,gCAAgC;EAChC,+BAA+B;EAC/B,6BAA6B;EAC7B,6BAA6B;EAC7B,gCAAgC;EAChC,kCAAkC;EAClC,4BAA4B;EAC5B,6BAA6B;EAC7B,kCAAkC;EAClC,6BAA6B;EAC7B,6CAA6C;EAC7C,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;EAC7B,mCAAmC;EACnC,8BAA8B;EAC9B,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,qBAAqB;EACrB,6BAA6B;EAC7B,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,8CAA8C;EAC9C,uCAAuC;EACvC,gCAAgC;EAChC,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,mCAAmC;EACnC,yBAAyB;EACzB,gCAAgC;EAChC,yBAAyB;EACzB,wBAAwB;EACxB,sCAAsC;EACtC,wCAAwC;EACxC,2CAA2C;EAC3C,yBAAyB;EACzB,8BAA8B;EAC9B,kCAAkC;EAClC,4BAA4B;EAC5B,2BAA2B;EAC3B,+BAA+B;EAC/B,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,+BAA+B;EAC/B,gDAAgD;EAChD,sBAAsB;EACtB,yBAAyB;EACzB,4CAA4C;EAC5C,0BAA0B;EAC1B,8BAA8B;EAC9B,+CAA+C;EAC/C,kDAAkD;EAClD,2BAA2B;EAC3B,2BAA2B;EAC3B,sBAAsB;EACtB,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B,yCAAyC;EACzC,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,+BAA+B;EAC/B,6BAA6B;EAC7B,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;EACxB,wBAAwB;EACxB,6BAA6B;EAC7B,iCAAiC;EACjC,sCAAsC;EACtC,wCAAwC;EACxC,oCAAoC;EACpC,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;EAC1B,qDAAqD;EACrD,+BAA+B;EAC/B,+BAA+B;EAC/B,6CAA6C;EAC7C,oCAAoC;EACpC,+CAA+C;EAC/C,yDAAyD;EACzD,sCAAsC;EACtC,oCAAoC;EACpC,sCAAsC;EACtC,0CAA0C;EAC1C,oCAAoC;EACpC,8BAA8B;EAC9B,sCAAsC;EACtC,+BAA+B;EAC/B,oCAAoC;EACpC,+CAA+C;EAC/C,6BAA6B;EAC7B,mCAAmC;EACnC,8DAA8D;EAC9D,iCAAiC;EACjC,uCAAuC;EACvC,2DAA2D;EAC3D,wCAAwC;EACxC,0CAA0C;EAC1C,8BAA8B;EAC9B,oCAAoC;EACpC,qCAAqC;EACrC,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,0BAA0B;EAC1B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,4CAA4C;EAC5C,oCAAoC;EACpC,gCAAgC;EAChC,kDAAkD;EAClD,yCAAyC;EACzC,+CAA+C;EAC/C,oCAAoC;EACpC,gCAAgC;EAChC,+BAA+B;EAC/B,yBAAyB;EACzB,gCAAgC;EAChC,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,gCAAgC;EAChC,kEAAkE;EAClE,sCAAsC;EACtC,4BAA4B;EAC5B,iCAAiC;EACjC,iCAAiC;EACjC,mCAAmC;EACnC,qDAAqD;EACrD,SAAS;EACT,SAAS;AACX;AACA;AACA;IACI,UAAU;AACd;AACA;AACA;AACA;IACI,UAAU;AACd;AACA;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,wCAAwC;EACxC,wCAAwC;EACxC,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;EACvB,gCAAgC;EAChC,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;EACxB,2CAA2C;EAC3C,4BAA4B;EAC5B,kCAAkC;EAClC,wBAAwB;EACxB,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;EAChC,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,mCAAmC;EACnC,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,+BAA+B;EAC/B,iCAAiC;EACjC,+BAA+B;EAC/B,gCAAgC;EAChC,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,kCAAkC;EAClC,mCAAmC;EACnC,+BAA+B;EAC/B,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,oCAAoC;EACpC,4BAA4B;EAC5B,oCAAoC;EACpC,4BAA4B;EAC5B,kCAAkC;EAClC,iDAAiD;EACjD,iCAAiC;EACjC,iCAAiC;EACjC,uCAAuC;EACvC,0BAA0B;EAC1B,8CAA8C;EAC9C,sBAAsB;EACtB,sBAAsB;EACtB,8BAA8B;EAC9B,iDAAiD;EACjD,iCAAiC;EACjC,2BAA2B;EAC3B,2BAA2B;EAC3B,gCAAgC;EAChC,uDAAuD;EACvD,qCAAqC;EACrC,8BAA8B;EAC9B,oDAAoD;EACpD,2CAA2C;EAC3C,0CAA0C;EAC1C,kDAAkD;EAClD,4CAA4C;EAC5C,8CAA8C;EAC9C,qCAAqC;EACrC,+BAA+B;EAC/B,8CAA8C;EAC9C,8CAA8C;EAC9C,iDAAiD;EACjD,mDAAmD;EACnD,yCAAyC;EACzC,8CAA8C;EAC9C,+CAA+C;EAC/C,6BAA6B;EAC7B,gDAAgD;EAChD,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;EAC7B,8BAA8B;EAC9B,mCAAmC;EACnC,8BAA8B;EAC9B,oCAAoC;EACpC,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,yCAAyC;EACzC,2BAA2B;EAC3B,8CAA8C;EAC9C,uCAAuC;EACvC,gCAAgC;EAChC,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,sCAAsC;EACtC,4BAA4B;EAC5B,yCAAyC;EACzC,yBAAyB;EACzB,4CAA4C;EAC5C,gDAAgD;EAChD,yCAAyC;EACzC,uCAAuC;EACvC,gCAAgC;EAChC,kCAAkC;EAClC,6CAA6C;EAC7C,6BAA6B;EAC7B,kCAAkC;EAClC,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,+BAA+B;EAC/B,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;EAC5B,4CAA4C;EAC5C,oCAAoC;EACpC,8BAA8B;EAC9B,4CAA4C;EAC5C,mCAAmC;EACnC,2BAA2B;EAC3B,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,0CAA0C;EAC1C,uBAAuB;EACvB,yBAAyB;EACzB,+BAA+B;EAC/B,6BAA6B;EAC7B,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;EACxB,2BAA2B;EAC3B,6BAA6B;EAC7B,iCAAiC;EACjC,sCAAsC;EACtC,wCAAwC;EACxC,wBAAwB;EACxB,8BAA8B;EAC9B,4CAA4C;EAC5C,kCAAkC;EAClC,0CAA0C;EAC1C,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,0CAA0C;EAC1C,0BAA0B;EAC1B,4BAA4B;EAC5B,+BAA+B;EAC/B,+BAA+B;EAC/B,oCAAoC;EACpC,+CAA+C;EAC/C,iDAAiD;EACjD,gCAAgC;EAChC,sCAAsC;EACtC,oCAAoC;EACpC,sCAAsC;EACtC,0CAA0C;EAC1C,oCAAoC;EACpC,8BAA8B;EAC9B,sCAAsC;EACtC,+BAA+B;EAC/B,oCAAoC;EACpC,+CAA+C;EAC/C,6BAA6B;EAC7B,mCAAmC;EACnC,qCAAqC;EACrC,iCAAiC;EACjC,yCAAyC;EACzC,oCAAoC;EACpC,0CAA0C;EAC1C,0CAA0C;EAC1C,gCAAgC;EAChC,oCAAoC;EACpC,qCAAqC;EACrC,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,0BAA0B;EAC1B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,4CAA4C;EAC5C,oCAAoC;EACpC,+CAA+C;EAC/C,kDAAkD;EAClD,yCAAyC;EACzC,4CAA4C;EAC5C,oCAAoC;EACpC,gCAAgC;EAChC,+BAA+B;EAC/B,yBAAyB;EACzB,gCAAgC;EAChC,iCAAiC;EACjC,kCAAkC;EAClC,kCAAkC;EAClC,gCAAgC;EAChC,sDAAsD;EACtD,sCAAsC;EACtC,4BAA4B;EAC5B,oCAAoC;EACpC,iCAAiC;EACjC,6CAA6C;EAC7C,kCAAkC;AACpC;AACA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,sBAAsB;EACtB,wCAAwC;EACxC,kCAAkC;EAClC,oCAAoC;EACpC,sCAAsC;EACtC,qCAAqC;AACvC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,iCAAiC;EACjC,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,uDAAuD;EACvD,oDAAoD;EACpD,+CAA+C;EAC/C,YAAY;EACZ,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,aAAa;EACb,wCAAwC;EACxC,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[":root {\n  --font-color: #424242;\n  --bg-color: #fff;\n  --bg-color-rgb1: rgba(255, 255, 255, 0.322);\n  --bg-color-rgb2: rgba(255, 255, 255, 0.5);\n  --bg-color2: #f8f8f8;\n  --bg-color3: #fff;\n  --ptt-bg-color: #e1e1e1;\n  --link-new-msgs-bgcolor: #fff;\n  --slide-arrow-color: #fff;\n  --slide-arrow-bg: #bdbdbd;\n  --heading-color: #292922;\n  --main-body-color: #000000e6;\n  --main-body-bgcolor: #f8f8f8;\n  --box-shadow: 0px 0px 17px #313131;\n  --toolbtn-color: #757575;\n  --toolbtn-color-hover: #a5a5a5;\n  --toolbtn-active-color: #00aafb;\n  --activity-line-bgcolor: #0277bd;\n  --dropdown-color: #292922;\n  --chat-text-color: #7c7c7c;\n  --chat-time-color: #808080;\n  --chat-system-color: #808080;\n  --chatlist-icon-color: #545454;\n  --message-bg-color1: #D8F6F7;\n  --message-bg-color2: #F0F0F0;\n  --message-next-color: #83C1EF;\n  --message-time-color: #808080;\n  --message-grey-color: grey;\n  --message-reply-color: grey;\n  --message-reply-bgcolor: #254b6a08;\n  --message-selected-bgcolor: #dbdbdb;\n  --switch-enabled-color: #2196F3;\n  --switch-disabled-color: #ccc;\n  --switch-btn-bgcolor: var(--bg-color);\n  --fwd-message-color: #808080;\n  --content-container-bgcolor: #fff;\n  --list-item-bgcolor: #fff;\n  --bot-message-color: #23527c;\n  --list-item-activebgcolor: #ebebeb82;\n  --list-item-bghover: #f8f8f870;\n  --list-item-horline-color: #F0F0F0;\n  --list-item-bordercolor: #f0f0f0;\n  --list-item-bordercolor2: #f0f0f0;\n  --contact-list-marked-bg: #ccd1d3;\n  --context-color: var(--main-body-color);\n  --context-bgcolor: var(--bg-color);\n  --context-bgcolor-hover: var(--bg-color-hover);\n  --btn-bghover: #e8eef7;\n  --progress-bg: #e8eef7;\n  --pub-footer-active: lightgrey;\n  --main-block-border-top: #d3d3d3;\n  --main-block-border-left: #d3d3d3;\n  --border-top-input: #ccc;\n  --border-info-left: #ccc;\n  --border-bottom-section: #ccc;\n  --border-bottom-selecteditems: #f0f0f0;\n  --circle-animation-bgcolor: #d3d5d385;\n  --circle-animation-color: #333;\n  --circle-animation-hover: #a5a5a5;\n  --vert-line-color: #d3d3d3;\n  --hor-line-color: #f0f0f0;\n  --asc-item-border-bottom: #f2f2f2;\n  --asc-status-hover: #fcfcfc;\n  --item-bgcolor-hover: #fcfcfc;\n  --transition-wrapper-bgcolor: #f2f2f2;\n  --chat-item-right-block-bg: #ccd1d3;\n  --message-link-color: #6083a2;\n  --message-system-color: #6083a2;\n  --message-system-bgcolor: #e4e4e4;\n  --message-left-bgcolor: #F0F0F0;\n  --message-right-bgcolor: #D8F6F7;\n  --search-input-bgcolor: #e7e7e7;\n  --search-more-border: #e7e7e7;\n  --search-rail-border: #f7f7f7;\n  --datepicker-cell-hover: #eaf8fe;\n  --datepicker-border-color: #d9d9d9;\n  --emoji-input-color: #808080;\n  --emoji-input-border: #d9d9d9;\n  --emoji-placeholder-color: #888888;\n  --emoji-hover-before: #f4f4f4;\n  --info-content-shadow: rgba(16, 15, 15, 0.43);\n  --icon-bgcolor: #ccd1d3;\n  --icon-bgcolor2: #00a2ff;\n  --blue-bgcolor: #005aab;\n  --like-color: #7f9eb9;\n  --blue-login-bgcolor: #005aab;\n  --blue-login-bgcolor-hover: #00489A;\n  --comment-btn-bgcolor: #d8dade;\n  --comment-btn-bgcolor-hover: #a5a5a5;\n  --base-blue-color: #0277bd;\n  --base-blue-color2: #2196F3;\n  --special-blue-color: #008ef7;\n  --special-blue-color2: #2688c2;\n  --icon-color: #ffffff;\n  --icon-special-color: #2196f3;\n  --icon-marked-color: #ffffff;\n  --icon-btn-color: #fff;\n  --icon-border-color: #fff;\n  --icon-btn-bgcolor: #9C9C9C;\n  --icon-wrapper-bgcolor: rgba(39, 39, 39, 0.21);\n  --icon-wrapper-bgcolor-hover: #272727ba;\n  --icon-btn-bgcolorhover: #535555;\n  --icon-roundbtn-color: #2196f3;\n  --icon-disabled-color: #7b7b7b;\n  --icon-btn-hover: #f0f0f07f;\n  --icon-btn-with-bg: #f0f0f0;\n  --custom-textarea-color: grey;\n  --listitem-headerfooter-color: grey;\n  --placeholder-color: #aaa;\n  --custom-textarea-color: #868686;\n  --bg-color-hover: #f3f3f3;\n  --divider-color: #f0f0f0;\n  --scroll-bar-color: rgba(0, 0, 0, 0.2);\n  --shifted-circle-border-color: lightgrey;\n  --conf-subheader-color: rgba(0, 0, 0, 0.55);\n  --conf-tab-hover: #cdd7ea;\n  --custom-tab-activebg: #e7e7e7;\n  --custom-tab-activeborder: #8a8080;\n  --custom-tab-border: #d2cece;\n  --custom-tab-hover: #dedede;\n  --link-new-message-shadow: #999;\n  --bootstrap-btn-color: #fff;\n  --func-btn-bgcolor: #F5F5F5;\n  --func-btn-bgactive: #929292;\n  --ref-link-color: #337ab7;\n  --ref-link-color-hover: #23527c;\n  --input-text-color: var(--custom-textarea-color);\n  --input-bg-color: #fff;\n  --clip-elem-bgcolor: #fff;\n  --clip-elem-shadow-color: rgba(0, 0, 0, 0.4);\n  --clip-cont-color: #808080;\n  --clip-cont-bgcolor: #f8f8f89e;\n  --phone-container-shadow: rgba(50, 50, 50, 0.5);\n  --mediaviewer-caption-bg: rgba(255, 255, 255, 0.7);\n  --modal-elem-color: #0097d3;\n  --modal-text-color: #757575;\n  --badge-red-color: red;\n  --elem-grey-color: #808080;\n  --elem-red-color: red;\n  --elem-green-color: green;\n  --conf-green-color: #00a91d;\n  --reply-red-color: var(--reply-red-color);\n  --phone-text-color: #7e7e7e;\n  --dialer-color: #4e4e4e;\n  --dialer-bgcolor: #fff;\n  --dialer-color-special: #868686;\n  --dialer-input-color: #3F3F3F;\n  --dial-button-bgcolor: #20B000;\n  --login-color: gray;\n  --login-bgcolor: #dadada;\n  --btns-block-color: #aaa;\n  --login-btns-bgcolor: #f5f5f5;\n  --videomost-main-bgcolor: #4f4c50;\n  --videomost-videocont-bgcolor: #585559;\n  --videomost-members-container: #4f4c50b8;\n  --vm-bg-color: rgba(79, 76, 80, 0.9);\n  --vm-bg-color-hover: #736e75;\n  --vm-divider-color: gray;\n  --vm-text-color: white;\n  --vm-title-color: lightgray;\n  --vm-footer-color: lightgray;\n  --vm-border-color: lightgray;\n  --vm-nocamera-bg: #534f54;\n  --vm-handup-wrapper-bg: #534f54;\n  --vm-btn-active: #7a818c2e;\n  --calendar-bg-color: var(--content-container-bgcolor);\n  --calendar-month-color: #2196f3;\n  --calendar-arrow-color: #686868;\n  --calendar-header-btn-hover-bg-color: #0c7bd3;\n  --calendar-header-btn-color: #2196f3;\n  --calendar-day-not-current-month-color: #7a7a7a;\n  --calendar-day-bg-color: var(--content-container-bgcolor);\n  --calendar-day-border-color: #c8cbd160;\n  --calendar-today-bg-color: #aec1d76b;\n  --calendar-today-border-color: #69AEE4;\n  --calendar-not-current-month-bg: #35414ca8;\n  --calendar-month-name-color: #5b95c3;\n  --calendar-hover-bg: #aabfd354;\n  --calendar-hover-border-color: #e7e0e0;\n  --calendar-event-color: #11a322;\n  --calendar-event-hover-bg: #9bcaf987;\n  --calendar-event-bottom-border-color: #7777772e;\n  --calendar-events-bg: #acc6e1;\n  --calendar-events-panel-bg: #2196f3;\n  --calendar-events-content-bg: var(--content-container-bgcolor);\n  --calendar-events-btn-bg: #2196f3;\n  --calendar-events-btn-hover-bg: #0c7bd3;\n  --calendar-edit-events-bg: var(--content-container-bgcolor);\n  --calendar-edit-events-hover-bg: #e7e4e4;\n  --calendar-edit-events-time-color: #D83B01;\n  --disabled-overlay-bg: #bdbdbd;\n  --unsent-replymsg-fio-color: #9d150c;\n  --unsent-replymsg-text-color: #636161;\n  --item-color-0: #f44336;\n  --item-color-1: #9c27b0;\n  --item-color-2: #2196F3;\n  --item-color-3: #4caf50;\n  --item-color-4: #00bcd4;\n  --item-color-5: #b71c1c;\n  --item-color-6: #1a237e;\n  --item-color-7: #e91e63;\n  --item-color-8: #455a64;\n  --item-color-9: #afb42b;\n  --item-color-10: #f57f17;\n  --item-color-11: #b7822c;\n  --item-color-12: #607d8b;\n  --item-color-13: #3f51b5;\n  --item-color-14: #8083d9;\n  --item-color-15: #33691e;\n  --item-color-16: #8bc34a;\n  --item-color-17: #880e4f;\n  --item-color-18: #ba4482;\n  --item-color-19: #673ab7;\n  --item-color-20: #0d47a1;\n  --item-color-21: #006064;\n  --item-color-22: #009688;\n  --item-color-23: #004d40;\n  --item-color-24: #827717;\n  --item-color-25: #ffc107;\n  --item-color-26: #e65100;\n  --item-color-27: #00b39c;\n  --item-color-28: #ff5722;\n  --item-color-29: #bf360c;\n  --item-color-30: #b4876e;\n  --item-color-31: #795548;\n  --item-color-32: #3e2723;\n  --item-color-33: #465776;\n  --item-color-34: #d500f9;\n  --item-color-35: #651fff;\n  --item-color-gray: #808080;\n  --highlighted-bgcolor: #699fbd;\n  --reaction-count-color: black;\n  --reaction-panel-color: white;\n  --reactions-items-toolbox-bgcolor: #d9d9d9e1;\n  --reactions-items-bgcolor: #cbc8c84f;\n  --reactions-picker-icon: #bbbbbb;\n  --reactions-panel-color: var(--message-grey-color);\n  --reactions-panel-totalbgcolor: #cbc8c84f;\n  --tetra-msg-notsent-color: rgba(0, 0, 0, 0.856);\n  --tetra-msg-notsent-bgcolor: #ff5353;\n  --bg-sound-btn: var(--bg-color2);\n  --bg-sound-btn-hover: #cbc8c84f;\n  --comments-color: #646464;\n  --comments-border-top: #cbc8c84f;\n  --bg-comments-hover-left: #8181814f;\n  --bg-comments-hover-right: #aeebed;\n  --bg-comments-after-hover: #aeebed;\n  --code-block-font-color: #ffffff;\n  --electron-notyfy-bg-color: 0px 0px 10px 0px rgba(50, 50, 50, 0.5);\n  --notyfy-title-subtitle-color: #6e6e6e;\n  --search-line-color: #2196f3;\n  --search-option-color-hover: #fff;\n  --search-option-bg-hover: #2196f3;\n  --group-link-message-color: #696868;\n  --group-join-line-color: var(--border-bottom-section);\n  --vh: 1vh;\n  --vw: 1vw;\n}\n@supports (height: 100dvh) {\n:root {\n    --vh: 1dvh;\n}\n}\n@supports (height: 100dvw) {\n:root {\n    --vw: 1dvw;\n}\n}\n[data-theme=\"dark\"] {\n  --font-color: #ffffff;\n  --bg-color: #151e27;\n  --bg-color-rgb1: rgba(91, 149, 195, 0.1);\n  --bg-color-rgb2: rgba(91, 149, 195, 0.2);\n  --bg-color2: #151e27;\n  --bg-color3: #1d2733;\n  --ptt-bg-color: #222d3a;\n  --link-new-msgs-bgcolor: #2e3b4a;\n  --slide-arrow-color: #fff;\n  --slide-arrow-bg: #2e3b4a;\n  --heading-color: #030303;\n  --main-body-color: rgba(248, 244, 244, 0.9);\n  --main-body-bgcolor: #1f1f27;\n  --box-shadow: 0px 0px 17px #313131;\n  --toolbtn-color: #7a90af;\n  --toolbtn-color-hover: #3b7db5;\n  --toolbtn-active-color: #5b95c3;\n  --activity-line-bgcolor: #0470af;\n  --dropdown-color: #808080;\n  --chat-text-color: #BDBDBD;\n  --chat-time-color: #808080;\n  --chat-system-color: #ffffff;\n  --chat-item-right-block-bg: #646464;\n  --chatlist-icon-color: #bbb8b8;\n  --message-bg-color1: #704d4d;\n  --message-bg-color2: #232323;\n  --message-next-color: #b4c8d8;\n  --message-time-color: #81a0ba;\n  --message-link-color: #6083a2;\n  --message-system-color: #6083a2;\n  --message-system-bgcolor: #212d3b;\n  --message-left-bgcolor: #222e3a;\n  --message-right-bgcolor: #295476;\n  --bot-message-color: #b8cbdb;\n  --message-grey-color: #81a0ba;\n  --message-reply-color: #93b8d6;\n  --message-reply-bgcolor: #1d3d5833;\n  --message-selected-bgcolor: #1a2734;\n  --switch-enabled-color: #2688c2;\n  --switch-disabled-color: #565656;\n  --switch-btn-bgcolor: #96a8b7;\n  --fwd-message-color: #81a0ba;\n  --content-container-bgcolor: #17212b;\n  --list-item-bgcolor: #17212b;\n  --list-item-activebgcolor: #43464852;\n  --list-item-bghover: #212d3b;\n  --list-item-horline-color: #2c2c2c;\n  --list-item-bordercolor: var(--message-bg-color2);\n  --list-item-bordercolor2: #565050;\n  --contact-list-marked-bg: #424242;\n  --context-color: var(--main-body-color);\n  --context-bgcolor: #1b2833;\n  --context-bgcolor-hover: var(--bg-color-hover);\n  --btn-bghover: #212d3b;\n  --progress-bg: #535353;\n  --pub-footer-active: #212d3ba8;\n  --main-block-border-top: var(--message-bg-color2);\n  --main-block-border-left: #353535;\n  --border-top-input: #353535;\n  --border-info-left: #353535;\n  --border-bottom-section: #353535;\n  --border-bottom-selecteditems: var(--message-bg-color2);\n  --circle-animation-bgcolor: #535b6677;\n  --circle-animation-color: #333;\n  --circle-animation-hover: var(--toolbtn-color-hover);\n  --vert-line-color: var(--message-bg-color2);\n  --hor-line-color: var(--message-bg-color2);\n  --asc-item-border-bottom: var(--message-bg-color2);\n  --asc-status-hover: var(--list-item-bghover);\n  --item-bgcolor-hover: var(--list-item-bghover);\n  --transition-wrapper-bgcolor: #696969;\n  --search-input-bgcolor: #212d3b;\n  --search-more-border: var(--message-bg-color2);\n  --search-rail-border: var(--message-bg-color2);\n  --datepicker-cell-hover: var(--list-item-bghover);\n  --datepicker-border-color: var(--message-bg-color2);\n  --emoji-input-color: var(--toolbtn-color);\n  --emoji-input-border: var(--message-bg-color2);\n  --emoji-placeholder-color: var(--toolbtn-color);\n  --emoji-hover-before: #231818;\n  --info-content-shadow: rgba(164, 164, 164, 0.08);\n  --blue-bgcolor: #004067;\n  --like-color: #4e87b3;\n  --icon-bgcolor: #4e87b3;\n  --icon-bgcolor2: #4e87b3;\n  --base-blue-color: #4e87b3;\n  --base-blue-color2: #22659a;\n  --special-blue-color: #4e87b3;\n  --blue-login-bgcolor: #22659a;\n  --special-blue-color2: #22659a;\n  --blue-login-bgcolor-hover: #1d4169;\n  --comment-btn-bgcolor: #22659a;\n  --comment-btn-bgcolor-hover: #1d4169;\n  --icon-color: var(--font-color);\n  --icon-special-color: #5b95c3;\n  --icon-marked-color: #ffffff;\n  --icon-btn-hover: #434f58c9;\n  --icon-btn-with-bg: #27323e;\n  --icon-btn-color: #22659a;\n  --icon-border-color: var(--toolbtn-color);\n  --icon-btn-bgcolor: #3c4652;\n  --icon-wrapper-bgcolor: rgba(39, 39, 39, 0.21);\n  --icon-wrapper-bgcolor-hover: #272727ba;\n  --icon-btn-bgcolorhover: #35393c;\n  --icon-roundbtn-color: #4886b7;\n  --icon-disabled-color: #7b7b7b;\n  --custom-textarea-color: #fff;\n  --listitem-headerfooter-color: #abb0b7;\n  --placeholder-color: #abb0b7;\n  --divider-color: var(--message-bg-color2);\n  --bg-color-hover: #212d3b;\n  --scroll-bar-color: rgba(194, 192, 192, 0.2);\n  --shifted-circle-border-color: var(--font-color);\n  --conf-subheader-color: var(--font-color);\n  --conf-tab-hover: var(--bg-color-hover);\n  --custom-tab-activebg: #354354a8;\n  --custom-tab-activeborder: #704d4d;\n  --custom-tab-border: var(--message-bg-color2);\n  --custom-tab-hover: #354354a8;\n  --link-new-message-shadow: #212d3b;\n  --bootstrap-btn-color: #fff;\n  --func-btn-bgcolor: #27323e;\n  --func-btn-bgactive: #668aa9;\n  --ref-link-color: #83b7dd;\n  --ref-link-color-hover: #23527c;\n  --input-text-color: #fff;\n  --input-bg-color: #3c4652;\n  --clip-elem-bgcolor: #404448;\n  --clip-elem-shadow-color: rgba(0, 0, 0, 0.4);\n  --clip-cont-color: var(--font-color);\n  --clip-cont-bgcolor: #404448ad;\n  --phone-container-shadow: rgba(0, 0, 0, 0.4);\n  --mediaviewer-caption-bg: #02020285;\n  --modal-elem-color: #3b7db5;\n  --modal-text-color: #fff;\n  --badge-red-color: #e04d4d;\n  --elem-grey-color: #81a0ba;\n  --elem-red-color: #d25050;\n  --elem-green-color: green;\n  --conf-green-color: green;\n  --reply-red-color: #d25050;\n  --phone-text-color: var(--chat-text-color);\n  --dialer-color: #558fbe;\n  --dialer-bgcolor: #1a2129;\n  --dialer-color-special: #6295be;\n  --dialer-input-color: #6295be;\n  --dial-button-bgcolor: #1b3c1b;\n  --login-color: #fff;\n  --login-bgcolor: #1d2733;\n  --btns-block-color: #3c4652;\n  --login-btns-bgcolor: #3c4652;\n  --videomost-main-bgcolor: #1e2833;\n  --videomost-videocont-bgcolor: #293440;\n  --videomost-members-container: #1e2833bd;\n  --vm-bg-color: #232d38d3;\n  --vm-bg-color-hover: #4b56618f;\n  --vm-divider-color: var(--message-bg-color2);\n  --vm-text-color: var(--font-color);\n  --vm-title-color: rgba(255, 255, 255, 0.9);\n  --vm-footer-color: #1d2733;\n  --vm-border-color: #1d2733;\n  --vm-nocamera-bg: #293440;\n  --vm-handup-wrapper-bg: var(--vm-bg-color);\n  --vm-btn-active: #7a818c2e;\n  --calendar-bg-color: #212d3b;\n  --calendar-month-color: #5b95c3;\n  --calendar-arrow-color: #686868;\n  --calendar-header-btn-color: #5b93c3;\n  --calendar-header-btn-hover-bg-color: #34638d7a;\n  --calendar-day-not-current-month-color: #ffffffb3;\n  --calendar-day-bg-color: #212d3b;\n  --calendar-day-border-color: #181b2098;\n  --calendar-today-bg-color: #2b47686b;\n  --calendar-today-border-color: #69AEE4;\n  --calendar-not-current-month-bg: #35414ca8;\n  --calendar-month-name-color: #5b95c3;\n  --calendar-hover-bg: #3f83c354;\n  --calendar-hover-border-color: #625a5a;\n  --calendar-event-color: #70c37a;\n  --calendar-event-hover-bg: #212d3b87;\n  --calendar-event-bottom-border-color: #7777772e;\n  --calendar-events-bg: #1d232a;\n  --calendar-events-panel-bg: #34648d;\n  --calendar-events-content-bg: #2a2a2a;\n  --calendar-events-btn-bg: #34648d;\n  --calendar-events-btn-hover-bg: #34638d7a;\n  --calendar-edit-events-bg: #363636cc;\n  --calendar-edit-events-hover-bg: #34638d21;\n  --calendar-edit-events-time-color: #D83B01;\n  --disabled-overlay-bg: #bdbdbd42;\n  --unsent-replymsg-fio-color: #cd1b0f;\n  --unsent-replymsg-text-color: #cd1b0f;\n  --item-color-0: #df4035;\n  --item-color-1: #b845cc;\n  --item-color-2: #2196F3;\n  --item-color-3: #51c255;\n  --item-color-4: #00bcd4;\n  --item-color-5: #c94141;\n  --item-color-6: #6d7bff;\n  --item-color-7: #e94079;\n  --item-color-8: #587482;\n  --item-color-9: #afb42b;\n  --item-color-10: #f57f17;\n  --item-color-11: #b7822c;\n  --item-color-12: #7fb9d6;\n  --item-color-13: #5d6bb9;\n  --item-color-14: #8083d9;\n  --item-color-15: #539a37;\n  --item-color-16: #8bc34a;\n  --item-color-17: #ce2f84;\n  --item-color-18: #ba4482;\n  --item-color-19: #8461c3;\n  --item-color-20: #2063cc;\n  --item-color-21: #1b959a;\n  --item-color-22: #2e998e;\n  --item-color-23: #049078;\n  --item-color-24: #827717;\n  --item-color-25: #ffc107;\n  --item-color-26: #e65100;\n  --item-color-27: #00b39c;\n  --item-color-28: #ff5722;\n  --item-color-29: #bf360c;\n  --item-color-30: #b4876e;\n  --item-color-31: #be978a;\n  --item-color-32: #b46556;\n  --item-color-33: #a5a5a5;\n  --item-color-34: #d500f9;\n  --item-color-35: #651fff;\n  --item-color-gray: #adadad;\n  --highlighted-bgcolor: #b4c8d8;\n  --reaction-count-color: white;\n  --reaction-panel-color: white;\n  --reactions-items-toolbox-bgcolor: #2c3438e3;\n  --reactions-items-bgcolor: #08090a26;\n  --reactions-picker-icon: var(--elem-grey-color);\n  --reactions-panel-color: var(--message-grey-color);\n  --reactions-panel-totalbgcolor: #1217184a;\n  --tetra-msg-notsent-color: var(--font-color);\n  --tetra-msg-notsent-bgcolor: #ff5353;\n  --bg-sound-btn: var(--bg-color3);\n  --bg-sound-btn-hover: #3447587a;\n  --comments-color: #e8e8e8;\n  --comments-border-top: #a5aaaf6b;\n  --bg-comments-hover-left: #676e76;\n  --bg-comments-hover-right: #357ab1;\n  --bg-comments-after-hover: #244865;\n  --code-block-font-color: #ffffff;\n  --electron-notyfy-bg-color: 0px 0px 10px 0px #0f0f0fc9;\n  --notyfy-title-subtitle-color: #d5d5d5;\n  --search-line-color: #153f62;\n  --search-option-color-hover: #96a7c0;\n  --search-option-bg-hover: #153f62;\n  --group-link-message-color: var(--font-color);\n  --group-join-line-color: #8787874a;\n}\n.theme-videoconf {\n  --bg-color: var(--vm-bg-color);\n  --bg-color-hover: var(--vm-bg-color-hover);\n  --bd-filter: blur(5px);\n  --divider-color: var(--vm-divider-color);\n  --text-color: var(--vm-text-color);\n  --title-color: var(--vm-title-color);\n  --footer-color: var(--vm-footer-color);\n  --border-color: var(--vm-boder-color);\n}\n.theme-videoconf .context-menu-group > .header {\n  background-color: inherit;\n}\n.theme-videoconf .list-item {\n  color: white;\n  background-color: inherit;\n}\n.theme-videoconf .item-footer {\n  color: var(--chat-text-color);\n}\n.incomming-call {\n  height: 300px;\n  width: 310px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  user-select: none;\n  border-radius: 10px;\n  background-color: var(--bg-color);\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);\n  -moz-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);\n  z-index: 100;\n  margin: 10px;\n}\n.incomming-call .close-btn {\n  position: absolute;\n  top: 7px;\n  right: 11px;\n  color: #D1D1D1;\n  cursor: pointer;\n  font-size: 15px;\n}\n.incomming-call .close-btn:hover {\n  color: #9e9a9a;\n}\n.incomming-call .icon-big {\n  width: 100px;\n  min-width: 100px;\n  height: 100px;\n  line-height: 100px;\n  font-size: 42px;\n  margin-top: 30px;\n}\n.incomming-call .name {\n  font-size: 20px;\n  margin-top: 10px;\n  max-width: 250px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  color: var(--font-color);\n}\n.incomming-call .type {\n  color: var(--message-grey-color);\n  font-size: 14px;\n}\n.incomming-call .buttons {\n  display: flex;\n  justify-content: space-around !important;\n  width: 100%;\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
